const DB_NAME = "pt_tracker_stopwatch_v1";
const STORE_NAME = "lap_actions";

export const elapsedWholeSeconds = (startedAt, now = Date.now()) =>
  Math.max(0, Math.floor((now - new Date(startedAt).getTime()) / 1000));

export const createLapAction = ({
  heatId,
  heatRunnerId,
  leaseVersion,
  actionType,
  elapsedSeconds,
  voidsActionId = null
}) => ({
  id: globalThis.crypto?.randomUUID?.() ||
    `lap-${Date.now()}-${Math.random().toString(16).slice(2)}`,
  heatId,
  heatRunnerId,
  leaseVersion,
  actionType,
  elapsedSeconds,
  voidsActionId,
  clientRecordedAt: new Date().toISOString()
});

const openDatabase = () => new Promise((resolve, reject) => {
  if (!globalThis.indexedDB) {
    reject(new Error("Offline stopwatch storage is unavailable."));
    return;
  }
  const request = indexedDB.open(DB_NAME, 1);
  request.onupgradeneeded = () => {
    const db = request.result;
    if (!db.objectStoreNames.contains(STORE_NAME)) {
      db.createObjectStore(STORE_NAME, { keyPath: "id" });
    }
  };
  request.onsuccess = () => resolve(request.result);
  request.onerror = () => reject(request.error);
});

const withStore = async (mode, operation) => {
  const db = await openDatabase();
  try {
    return await new Promise((resolve, reject) => {
      const transaction = db.transaction(STORE_NAME, mode);
      const store = transaction.objectStore(STORE_NAME);
      const result = operation(store);
      transaction.oncomplete = () => resolve(result);
      transaction.onerror = () => reject(transaction.error);
      transaction.onabort = () => reject(transaction.error);
    });
  } finally {
    db.close();
  }
};

export const queueLapAction = (action) =>
  withStore("readwrite", (store) => store.put(action));

export const removeQueuedLapAction = (id) =>
  withStore("readwrite", (store) => store.delete(id));

export const listQueuedLapActions = async () => {
  const db = await openDatabase();
  try {
    return await new Promise((resolve, reject) => {
      const transaction = db.transaction(STORE_NAME, "readonly");
      const request = transaction.objectStore(STORE_NAME).getAll();
      request.onsuccess = () => resolve(request.result || []);
      request.onerror = () => reject(request.error);
    });
  } finally {
    db.close();
  }
};

export const syncQueuedLapActions = async (send) => {
  const actions = await listQueuedLapActions();
  const ordered = [...actions].sort((a, b) =>
    a.clientRecordedAt.localeCompare(b.clientRecordedAt)
  );
  let synced = 0;
  for (const action of ordered) {
    await send(action);
    await removeQueuedLapAction(action.id);
    synced += 1;
  }
  return synced;
};
